/**
 * Grand-prize content for a competition. Structured so it can be authored in
 * Loomlite Admin (LL-418c) rather than scraped out of the free-text
 * Description. Until the `GrandPrize` column ships, `resolveGrandPrize` falls
 * back to a sensible default so the prize band always renders.
 */
export interface GrandPrizeContent {
	headline: string;
	perks: string[];
}

export const DEFAULT_GRAND_PRIZE: GrandPrizeContent = {
	headline: 'Featured in the Compendium results + Loomlite Guild credit',
	perks: [
		'Featured placement on the Loomlite results page',
		'Permanent “Laureate” profile frame',
		'Winning entry highlighted across Loomlite',
	],
};

/**
 * Returns the competition's authored grand prize, or the default when none has
 * been set yet. Structural param so this stays free of a `useCompetitions`
 * import cycle.
 */
export function resolveGrandPrize(competition: {
	GrandPrize?: GrandPrizeContent | null;
}): GrandPrizeContent {
	const gp = competition.GrandPrize;
	// Authored if a headline is set; perks are optional embellishment. This
	// mirrors the admin form, which lets an editor save a headline with no
	// perks — we honor that rather than silently substituting the default.
	if (gp && gp.headline?.trim()) {
		return { headline: gp.headline, perks: Array.isArray(gp.perks) ? gp.perks : [] };
	}
	return DEFAULT_GRAND_PRIZE;
}
